import { render, staticRenderFns } from "./review_google_tab.vue?vue&type=template&id=3ec50ff6&scoped=true&"
import script from "./review_google_tab.vue?vue&type=script&lang=js&"
export * from "./review_google_tab.vue?vue&type=script&lang=js&"
import style0 from "./review_google_tab.vue?vue&type=style&index=0&id=3ec50ff6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec50ff6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ec50ff6')) {
      api.createRecord('3ec50ff6', component.options)
    } else {
      api.reload('3ec50ff6', component.options)
    }
    module.hot.accept("./review_google_tab.vue?vue&type=template&id=3ec50ff6&scoped=true&", function () {
      api.rerender('3ec50ff6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/review/location/tabs/review_google_tab.vue"
export default component.exports